<template>
  <div class="card-update-videos">
    <card title="Add Slides">

      <div class="form-group">
        <label>Autoplay Videos</label>
        <toggle-button 
          v-model="page.autoplayVideos" 
          :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
          :sync="true"
          :width="30" 
          :height="20"
        />
      </div>

      <div class="form-group">
        <label>Select Videos</label>
        <input-asset 
          v-if="areVideoIdsReady"
          v-model="videoIds"
          :returnid="true"
          :multiple="true"
        />
      </div>

      <div class="video-slides">
        <label>Edit Slides</label>
        <div v-for="slide in page.videos" :key="slide.assetId" class="slide">
          <div class="slide__thumbnail">
            <img :src="slide.asset ? $store.state.assetsPath + slide.asset.thumbPath : null" alt="">
          </div>
          <div class="slide__label">
            <input class="form-control" type="text" v-model="slide.label[activeLanguage.code]" placeholder="label">
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InfoBox from '@/components/InfoBox'
import InputAsset from '@/components/InputAsset'
import _ from 'lodash'

export default {
  name: 'card-update-videos',

  components: { InfoBox, InputAsset },

  data() {
    return {
      areVideoIdsReady: false,
      videoIds: []
    }
  },

  watch: {
    videoIds (newIds) {
      const currentSlideIds = this.page.videos.map(asset => asset.assetId)
      let videoSlides = []

      newIds.forEach(id => {
        if(_.includes(currentSlideIds, id)) {
          const currentSlide = this.page.videos.filter(slide => {
            if (slide.assetId === id) {
              return slide
            }
          })

          videoSlides.push(currentSlide[0])
        } else {
          let currentSlide = this.$store.state.assetLibrary.assets.filter(asset => {
            if (asset._id === id) {
              return asset
            }
          })

          
          
          
          videoSlides.push({
            assetId: currentSlide[0]._id,
            asset: currentSlide[0],
            label: {
              en: ''
            }
          })
        }
      })

      console.log('')
      

      this.page.videos = videoSlides
    }
  },

  computed: {
    ...mapGetters([
      'activeLanguage',
      'page'
    ]),

    videos () {
      return this.$store.state.assetLibrary.assets.filter(asset => _.includes(this.videoIds, asset._id))
    }
  },

  mounted () {
    this.setVideos()
  },

  methods: {
    setVideos () {
      this.videoIds = this.page.videos.map(video => video.assetId)
      this.areVideoIdsReady = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
@import '@/styles/_mixins.scss';

.card-update-videos {
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}

.video-slides {

}

.slide {
  align-items: center;
  display: flex;
  margin: 0 0 10px;

  &__thumbnail {
    border-radius: 3px;
    height: 60px;
    margin: 0 10px 0 0;
    overflow: hidden;
    width: 105px;

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__label {

  }
}
</style>
